var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"argreement-main"},[_c('van-overlay',{staticClass:"overlay",attrs:{"show":_vm.loading}},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1),_c('p',{staticClass:"main-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{ref:"main_text",staticClass:"main-text",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }